import styled from "styled-components";
import { ButtonStyledComponent } from "components/button/button.style";
import { TicketIcon, SchoolIcon } from "components/svgs";
import { ActionButtons } from "styles/bootcamp/bootcamp";
import { EventSchedule } from "./event-info-card-list";
import { MediaSection } from "./media";

const parentCTALink =
   "https://docs.google.com/forms/d/e/1FAIpQLSdoPhpksu_ELUt8aRg9aZAveKRQ-25GLIvCfcaN8Dq3Y5WfHw/viewform";
const schoolCTALink =
   "https://docs.google.com/forms/d/e/1FAIpQLSdApwh6cz0Kwynng1y-zko83J543Yyy9dYPfV5AW-EU7NxTtA/viewform";

const BodySection: React.FC<any> = () => {
   return (
      <BodySection_SC>
         <ActionContainer>
            <HeroActionBtns>
               <ButtonStyledComponent
                  as={"a"}
                  href={parentCTALink}
                  style={{
                     background: "linear-gradient(to right, #CE04F1, #77028B)",
                     color: "white",
                     borderRadius: "35px",
                  }}
                  variant="unstyled"
                  size={"small"}
               >
                  <span style={{ paddingRight: "8px" }}>
                     <TicketIcon />
                  </span>
                  Register to Attend
               </ButtonStyledComponent>
               <ButtonStyledComponent
                  style={{ borderRadius: "35px", color: "#666666", borderColor: "#666666" }}
                  variant="outline-white"
                  as={"a"}
                  href={schoolCTALink}
                  size={"small"}
               >
                  <span style={{ paddingRight: "8px" }}>
                     <SchoolIcon />
                  </span>
                  showcase your institution
               </ButtonStyledComponent>
            </HeroActionBtns>
            <Divider_SC />
         </ActionContainer>
         <EventSchedule />
         <MediaSection />
      </BodySection_SC>
   );
};

const BodySection_SC = styled.section`
   display: flex;
   flex-direction: column;
   align-items: center;
   /* & .event-schedule { */
   padding: 2rem 2rem;
   /* } */
   @media screen and (min-width: 768px) {
      & .event-schedule {
         max-width: 1180px;
      }
   }
`;

const Divider_SC = styled.div`
   margin: 1rem 0;
   height: 1px;
   width: 100%;
   /* padding: 0rem !important; */

   background-color: #e3e3e3;
`;

const ActionContainer = styled.div`
   width: 100%;
`;

const HeroActionBtns = styled(ActionButtons)`
   align-items: flex-start;
   padding: 1rem 0;
   margin: 1.5rem 0;
   width: 100%;
   @media screen and (min-width: 768px) {
      justify-content: center;
      flex-direction: row;
   }
`;

export { BodySection };
